/*
 * Functions to update the demandbase Email field and notify the demandbase
 * library that it has changed so that more accurate information can be embedded
 * into marketo forms.
 */

/**
 * Initialize the event listeners only if there is:
 * - A hidden field with an id=Email
 * - One or more input[type-email]
 */
export function initDemandbaseEmailUpdate() {
  if (hasDemandbaseEmailField() && hasFormWithEmailField()) {
    const emailElms = document.querySelectorAll("input[type=email]");
    for (const emailElm of emailElms) {
      if (!(emailElm instanceof HTMLInputElement)) continue;
      emailElm.addEventListener("change", handleEvent);
    }
  }
}

const demandbaseEmailFieldSelector = "input[type=hidden]#Email";

function hasDemandbaseEmailField() {
  return document.querySelector(demandbaseEmailFieldSelector) != null;
}

function hasFormWithEmailField() {
  return document.querySelector("input[type=email]") != null;
}

/** @arg {Event} evt */
function handleEvent(evt) {
  const formEmailElm = evt.target;
  if (formEmailElm instanceof HTMLInputElement) {
    const demandBaseEmailElm = document.querySelector(
      demandbaseEmailFieldSelector,
    );
    if (demandBaseEmailElm instanceof HTMLInputElement) {
      demandBaseEmailElm.value = formEmailElm.value;
      demandBaseEmailElm.dispatchEvent(new Event("change"));
    }
  }
}
